import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export interface EStatementPreferencesDTO {
  isEmailStatementEnabled: boolean;
  email: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

const fetchEStatementPreferences = (clientId: string): Promise<EStatementPreferencesDTO> => {
  return authFetch(
    urlWithParams('/Consumer/EStatementSettings', {
      clientId,
    }),
  );
};

export const useEStatementPreferencesQuery = () => {
  const { clientId } = useRouteParams();

  return useQuery(queryKeys.eStatementPreferences(clientId), () =>
    fetchEStatementPreferences(clientId),
  );
};
